(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Collection-Product-video"] && !window.DesignMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
  const video = document.getElementById("video");
  const circlePlayButton = document.getElementById("circle-play-b");

  function togglePlay() {
    if (video.paused || video.ended) {
      video.play();
    } else {
      video.pause();
    }
  }

  circlePlayButton.addEventListener("click", togglePlay);
  video.addEventListener("playing", function () {
    circlePlayButton.style.opacity = 0;
  });
  video.addEventListener("pause", function () {
    circlePlayButton.style.opacity = 1;
  });
});
    document.getElementById('video').addEventListener('loadedmetadata', function() {
      document.getElementById('video').play().catch(function(error) {
          console.error("Play failed:", error);
      });
  });

    // Example sequential play and pause
  var video = document.getElementById('video');
  video.play().then(function() {
      // Video has started playing, you can pause it after some time if needed
      setTimeout(function() {
          video.pause();
      }, 5000); // Pause after 5 seconds
  }).catch(function(error) {
      console.error("Play failed:", error);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["template-article"]) return;
  try {
    
       $(document).ready(function () {
        document.getElementById("myDIVs").style.display = 'none';
      });
  
  } catch(e) { console.error(e); }
})();
})();
